module.exports = __webpack_public_path__ + "static/media/arrow2.59043536.svg";